export default __webpack_public_path__ + "static/media/carousel7.acd9f4e1.jpg";